import { useEffect, useRef, useState, useSyncExternalStore } from 'react';
import { answerDialog, currentDialog, subscribeDialog } from '../lib/dialogs';

/** The one window for confirmDialog / promptDialog (lib/dialogs.ts), rendered once at the root of the app. */
export function DialogHost() {
  const req = useSyncExternalStore(subscribeDialog, currentDialog);
  const ref = useRef<HTMLDialogElement>(null);
  const [text, setText] = useState('');
  // When the current question appeared: clicks in the first moment belong to the previous window (double-click on OK).
  const shownAt = useRef(0);

  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (req) {
      shownAt.current = Date.now();
      setText(req.defaultValue);
      if (!d.open) d.showModal();
    } else if (d.open) d.close();
  }, [req]);

  const settled = () => Date.now() - shownAt.current > 300;
  const cancel = () => { if (settled()) answerDialog(req?.kind === 'prompt' ? null : false); };
  const ok = () => { if (settled()) answerDialog(req?.kind === 'prompt' ? text : true); };
  // The first line of the message is the question; the rest (after a blank line or line breaks) is detail.
  const [title, ...rest] = (req?.message ?? '').split('\n');

  return (
    <dialog ref={ref} className="modal ask-dialog" aria-labelledby="ask-dialog-t" onCancel={(e) => { e.preventDefault(); cancel(); }}>
      {req && (
        <form method="dialog" onSubmit={(e) => { e.preventDefault(); ok(); }}>
          <h3 id="ask-dialog-t" dir="auto">{title}</h3>
          {rest.join('\n').trim() && <p className="ask-detail" dir="auto">{rest.join('\n').trim()}</p>}
          {req.kind === 'prompt' && (
            <input autoFocus aria-labelledby="ask-dialog-t" value={text} maxLength={2000} onChange={(e) => setText(e.target.value)} dir="auto" />
          )}
          <div className="actions">
            <button type="button" className="btn ghost" onClick={cancel}>Cancel</button>
            <button type="submit" className="btn primary" autoFocus={req.kind === 'confirm'}>OK</button>
          </div>
        </form>
      )}
    </dialog>
  );
}
